import { createApi } from "@reduxjs/toolkit/query/react";

import apiConfig from "configs/apiConfig";
import { REDUCER_PATHS } from "store/config";
import { transformResponseHandler } from "utils/transformResponseHandler";

import { customFetchBase } from ".";

const dividendApi = createApi({
  reducerPath: REDUCER_PATHS.DIVIDEND,
  baseQuery: customFetchBase,
  endpoints: (builder) => ({
    propertyDividendList: builder.query({
      query: (data) => ({
        url: `${apiConfig.DIVIDEND}?page=${data?.page}&pageSize=${data?.pageSize}&searchText=${data.searchText}&sortColumn=${data.sortColumn}&sortDirection=${data.sortDirection}`,
        method: "GET",
      }),
      providesTags: ["propertyDividendList"],
    }),
    propertyDividendUserList: builder.query({
      query: (data) => ({
        url: `${apiConfig.DIVIDEND_USER}/?page=${data?.page}&pageSize=${data?.pageSize}&searchText=${data.searchText}&sortColumn=${data.sortColumn}&sortDirection=${data.sortDirection}&propertyDividendId=${data?.propertyDividendId}&filter=${data?.filter}`,
        method: "GET",
      }),
      providesTags: ["propertyDividendList"],
    }),
    editPropertyDividendList: builder.mutation({
      query: (data) => ({
        url: `${apiConfig.DIVIDEND}/${data?.depositId}`,
        body: data?.body,
        method: "PUT",
      }),
      invalidatesTags: ["DividendList"],
      transformResponse: (resp) => transformResponseHandler(resp),
    }),
    propertyDividendListChangeStatus: builder.mutation({
      query: (data) => ({
        url: apiConfig.DIVIDEND,
        body: data,
        method: "PATCH",
      }),
      invalidatesTags: ["DividendList"],
      transformResponse: (resp) => transformResponseHandler(resp),
    }),
    propertyDividendListDelete: builder.mutation({
      query: (data) => ({
        url: apiConfig.DIVIDEND,
        method: "DELETE",
        body: data,
      }),
      invalidatesTags: ["DividendList"],
      transformResponse: (resp) => transformResponseHandler(resp),
    }),
    addPropertyDividendList: builder.mutation({
      query: (data) => ({
        url: apiConfig.DIVIDEND,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["DividendList"],
      transformResponse: (resp) => transformResponseHandler(resp),
    }),
    propertyDividendDetails: builder.query({
      query: (data) => ({
        url: `${apiConfig.DIVIDEND}/${data?.depositId}`,
        method: "GET",
      }),
      providesTags: ["DividendList"],
    }),
    propertyDividendDownload: builder.mutation({
      query: (data) => {
        const params = new URLSearchParams();

        if (data.filter) params.append("filter", data.filter);
        if (data.column) params.append("column", data.column);

        return {
          url: `${apiConfig.DIVIDEND_DOWNLOAD}/${
            data.type
          }?${params.toString()}`,
          method: "GET",
        };
      },
    }),
  }),
});

export const {
  useAddPropertyDividendListMutation,
  useLazyPropertyDividendListQuery,
  useLazyPropertyDividendUserListQuery,
  usePropertyDividendListChangeStatusMutation,
  usePropertyDividendListDeleteMutation,
  useLazyPropertyDividendDetailsQuery,
  useEditPropertyDividendListMutation,
  usePropertyDividendDownloadMutation,
} = dividendApi;

export default dividendApi;
